import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('user', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: props.colors[0]
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7272079,3.90581936 C11.7272079,6.06294918 9.97857692,7.81163872 7.82143734,7.81163872 C5.66431729,7.81163872 3.91562774,6.06294918 3.91562774,3.90581936 C3.91562774,1.74868954 5.66431729,0 7.82143734,0 C9.97857692,0 11.7272079,1.74868954 11.7272079,3.90581936 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.260395362,14.14528 C0.73666002,11.6052344 2.95454471,9.76452399 5.53890174,9.76452399 L10.4610421,9.76452399 C13.0454186,9.76452399 15.2633326,11.6052344 15.7395484,14.14528 L15.982978,15.4432782 C16.0956606,16.044187 15.6345798,16.5996908 15.023223,16.5996908 L0.976750136,16.5996908 C0.365354231,16.5996908 -0.0956514054,16.044187 0.017021437,15.4432782 L0.260395362,14.14528 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91454208,9.97104367 C7.93306538,9.85220942 8.03543665,9.76452399 8.15573558,9.76452399 L8.26102645,9.76452399 L8.36631731,9.76452399 C8.48662601,9.76452399 8.58899728,9.85220942 8.60752058,9.97104367 L9.19009161,13.7094893 C9.20132081,13.7814539 9.17983886,13.8546878 9.13140682,13.9091738 L8.44348634,14.68311 C8.34637815,14.792375 8.17568451,14.792375 8.07857632,14.68311 L7.39067536,13.9091738 C7.34225309,13.8546878 7.32070279,13.7814539 7.33193199,13.7094893 L7.91454208,9.97104367 Z"
  })))));
});